
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Programmatic cache-buster to clear the stale service worker and caches
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    let unregistredAny = false;
    for (const registration of registrations) {
      registration.unregister();
      unregistredAny = true;
    }
    if (unregistredAny && typeof window !== 'undefined') {
      console.log('Stale service worker found and unregistered. Clearing caches...');
      if ('caches' in window) {
        caches.keys().then((keys) => {
          Promise.all(keys.map(key => caches.delete(key))).then(() => {
            console.log('Caches cleared successfully. Reloading page...');
            window.location.reload();
          });
        });
      } else {
        window.location.reload();
      }
    }
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
